<template>
  <div id="chart-line-item-item-box">
    <chart-title
      leftTitle="PDM门型销售榜 left_3"
      :rightTitle="`${formatTime(date, 'yyyy年MM月')}`"
      :tooltipText="'实时开单门型面积'"
      ><el-button
        type="primary"
        slot="detail"
        size="mini"
        style="margin-left: 10px"
        @click="handleDetail"
        >详 情</el-button
      ></chart-title
    >
    <date-change-card
      height="calc(100% - 30px)"
      @leftClick="leftClick"
      @rightClick="rightClick"
    >
      <div id="left_3" slot="main" />
    </date-change-card>
  </div>
</template>

<script>
import resize from "@/utils/resize";
import ChartTitle from "../../../components/chartTitle";
import DateChangeCard from "../../../components/dateChangeCard";
import { getDoor } from "@/api/cockpit/vrhouse";
import { formatTime, getNextMonth, getLastDate } from "@/utils/index";
export default {
  mixins: [resize],
  name: "left_3",
  components: { ChartTitle, DateChangeCard },
  data() {
    return {
      chart: null,
      date: new Date(),
      chartData: "",
    };
  },
  props: {},
  created() {},
  mounted() {
    this.getData();
  },

  beforeDestroy() {
    if (!this.chart) {
      return;
    }
    this.chart.dispose();
    this.chart = null;
  },
  methods: {
    formatTime,
    //获取数据
    getData() {
      getDoor({
        month: getLastDate(formatTime(this.date, "yyyy-MM-dd")),
      }).then((resp) => {
        this.chartData = resp.data;
        this.initChart();
      });
    },
    initChart() {
      this.chart = this.$echarts.init(document.getElementById("left_3"));
      this.setOptions();
    },
    setOptions() {
      const color = ["59,157,255", "34,228,255", "59,255,208", "4,227,138"];
      let chartData = this.chartData.map((m) => {
        return { value: m.num };
      });
      chartData = chartData.map((m, i) => {
        return {
          value: m.value,
          itemStyle: {
            color: new this.$echarts.graphic.LinearGradient(1, 0, 0, 0, [
              {
                offset: 0,
                color: `rgba(${color[i % 4]},1)`,
              },
              {
                offset: 1,
                color: `rgba(${color[i % 4]},0.1)`,
              },
            ]),
          },
        };
      });
      this.chart.setOption({
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
        },
        legend: {
          orient: "vertical",
          left: "center",
          bottom: "2%",
          textStyle: {
            color: "#ffffff",
            fontSize: "10",
          },
          show: false,
        },
        grid: {
          top: "10%",
          bottom: "5%",
          right: "16%",
          left: "8%",
          center: "center",
          containLabel: true,
        },
        xAxis: {
          type: "value",
          boundaryGap: [0, 0.01],
          axisLabel: {
            color: "#606266",
            fontSize: "10",
          },
          axisLine: {
            lineStyle: {
              color: "#606266",
            },
          },
          splitLine: {
            lineStyle: {
              color: "#606266",
              type: "dashed", //设置网格线类型 dotted：虚线 solid:实线
            },
          },
        },
        yAxis: {
          type: "category",
          inverse: true,
          axisLine: {
            lineStyle: {
              color: "#606266",
            },
          },
          axisLabel: {
            color: "#909399",
            fontSize: "10",
          },
          data: this.chartData.map((m) => m.code),
        },
        series: [
          {
            name: "销售面积（㎡）",
            type: "bar",
            barWidth: 5,
            itemStyle: {
              borderRadius: 5,
            },
            data: chartData,
          },
        ],
      });
    },
    //前一月
    leftClick() {
      this.date = getNextMonth(formatTime(this.date, "yyyy-MM-dd"), -1);
      this.getData();
    },
    //后一月
    rightClick() {
      this.date = getNextMonth(formatTime(this.date, "yyyy-MM-dd"), +1);
      this.getData();
    },
    handleDetail() {
      window.open(
        `${process.env.VUE_APP_VRHOUSE_URL}/boss/admin/statement/production/door?jiashicang02`,
        "_blank"
      );
    },
  },
};
</script>

<style lang="scss" scoped>
#chart-line-item-item-box {
  // background: rgba(125, 155, 243, 0.2);
  height: 60vh;
  #left_3 {
    height: 100%;
  }
}
</style>
